import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import PropTypes, { object } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const TranslationDetails = (props) => {
  const { passedValue } = props;
  const classes = useStyles();

  return (
    <div>
      {passedValue
        ? passedValue.map((translation, index) => {
            let tempDate;
            try {
              tempDate = new Date(translation.datetime);
              tempDate = tempDate
                .toLocaleString("en-AU", { hour12: true })
                .toUpperCase();
            } catch (e) {
              tempDate = translation.datetime;
            }
            return (
              <Paper
                key={index}
                style={{ padding: "10px", margin: "10px" }}
                elevation={3}
              >
                <Grid container direction="column">
                  <Grid item>
                    <Typography
                      variant="subtitle2"
                      style={{ textTransform: "none" }}
                    >
                      Translated from {translation.translated_from}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ textTransform: "capitalize" }}
                    >
                      <span className={classes.nameSpan}>
                        {translation.name}
                      </span>{" "}
                      | {tempDate}
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ textTransform: "none" }}
                    >
                      {translation.text_message}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            );
          })
        : null}
    </div>
  );
};

TranslationDetails.propTypes = {
  passedValue: PropTypes.arrayOf(object),
};

export default TranslationDetails;
